module.exports = __webpack_public_path__ + "img/admin1.2319f7ad.svg";